import { Paper, styled } from "@material-ui/core";

export const Card = styled(Paper)(({ theme }) => ({
  borderLeft: "0.5rem solid transparent",
  overflow: "hidden",
  padding: theme.spacing(1),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(2),
  },
}));
